import apiClient from "./axiosConfig";

// Get categories list with search and pagination
export const getCategoriesList = async (params = {}) => {
  try {
    const { search = '', page = 1, page_size = 10, brand_id } = params;
    const queryParams = new URLSearchParams();
    
    if (search) queryParams.append('search', search);
    if (page) queryParams.append('page', page);
    if (page_size) queryParams.append('page_size', page_size);
    if (brand_id) queryParams.append('brand_id', brand_id);
    
    const response = await apiClient.get(`/products/category/list/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create new category
export const createCategory = async (categoryData) => {
  try {
    const formData = new FormData();
    formData.append('name', categoryData.name);
    formData.append('description', categoryData.description || '');
    
    if (categoryData.image) {
      if (typeof categoryData.image === 'object') {
        formData.append('image', categoryData.image);
      }
      // If it's a string (existing image URL), we don't need to append it
      // The backend will handle keeping the existing image
    }
    
    const response = await apiClient.post('/products/category/create/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update category
export const updateCategory = async (categoryId, categoryData) => {
  try {
    const formData = new FormData();
    formData.append('name', categoryData.name);
    formData.append('description', categoryData.description || '');
    
    if (categoryData.image) {
      if (typeof categoryData.image === 'object') {
        formData.append('image', categoryData.image);
      }
      // If it's a string (existing image URL), we don't need to append it
      // The backend will handle keeping the existing image
    }
    
    const response = await apiClient.patch(`/products/category/update/${categoryId}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete category
export const deleteCategory = async (categoryId) => {
  try {
    const response = await apiClient.delete(`/products/category/delete/${categoryId}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get category statistics
export const getCategoryStats = async () => {
  try {
    const response = await apiClient.get('/products/category/count/');
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get brands list by category ID
export const getBrandsByCategory = async (categoryId, params = {}) => {
  try {
    const { search = '', page = 1, page_size = 100 } = params;
    const queryParams = new URLSearchParams();
    
    if (search) queryParams.append('search', search);
    if (page) queryParams.append('page', page);
    if (page_size) queryParams.append('page_size', page_size);
    if (categoryId) queryParams.append('category_id', categoryId);
    
    const response = await apiClient.get(`/products/brand/list/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};